import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import PayrollSystemsWrapper from "@components/layouts/payrollSystemsWrapper";

export default function InsureYourCarHome(): ReactElement {
    return (
        <PayrollSystemsWrapper>
            <TermsAndConditions
                category="Pay Roll Systems"
                domain="PayrollSystems.com"
            />
        </PayrollSystemsWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
